const defaultFAQ = [
  {
    heading: 'Do I need Wi-Fi or a landline? ',
    details:
      'Our hub is set up so you can connect it directly into your internet router, and it comes with 4G cellular backup, so if you don’t have internet, no problem. This dual ethernet/4G connection means that when your power goes down, your security system will keep working. Our sensors connect to the hub via a radio connection. Our cameras do require a 2.4 GHz Wi-Fi connection, but they are the only equipment that relies only on Wi-Fi.',
  },
  {
    heading: 'Do I need a certain cell phone provider?',
    details:
      'No. When you sign up for a Cove monitoring plan, we handle the 4G cellular connection and subscription ourselves. It is completely separate from your personal cell phone plan. If you’re concerned about the coverage in your area, you can always give us a try with our 60-day money-back guarantee.',
  },
  {
    heading: 'What happens if the power goes out?',
    details:
      'If your power goes out, you might be alone in a dark house with no Netflix, but Cove will continue to protect your home. The hub includes a 48-hour backup battery to protect you against power outages.',
  },
  {
    heading: 'What equipment does Cove offer?',
    details:
      'Cove offers a variety of professional equipment, including a hub, a touchscreen alarm panel, indoor and outdoor cameras, anti-burglary sensors, environmental sensors, medical alerts, and keyfobs.',
  },
  {
    heading: 'How do I install Cove’s security system? ',
    details:
      'To install your system, just plug in your hub, wait for the network connectivity light to turn on, then connect your alarm panel to the hub with the included ethernet cable. Once you’ve plugged in your alarm panel, our intuitive installation guide will walk you through exactly how to name and place each of your sensors around your home. Each device comes with an adhesive strip on the back to make placing the sensors even easier. The time it takes to set up your system will depend on the number of sensors you have. If you’re having trouble setting up your system, our customer support team is always happy to help.',
  },
  // {
  //   heading: 'Where should I install the Touchscreen Panel?',
  //   details:
  //     'To install your system, just plug in your hub, wait for the network connectivity light to turn on, then connect your alarm panel to the hub with the included ethernet cable. Once you’ve plugged in your alarm panel, our intuitive installation guide will walk you throught exactly how to name and place each of your sensors around your home. Each device comes with an adhesive strip on the back to make placing the sensors even easier. The time it takes to set up your system will depend on the number of sensors you have. If you’re having trouble setting up your system, our customer support team is always happy to help.',
  // },
  // {
  //   heading: 'How does the 60-day money-back guarantee work?',
  //   details:
  //     'We’re so confident that you’re going to love your Cove system, we give you 60 days to try it out! If within 60 days you decide it’s not working out for you, send it back for a full refund. We’ll even cover shipping costs!',
  // },
  // {
  //   heading:
  //     "What's the difference between the SkyBell and Kami Doorbell Cameras?",
  //   details:
  //     'Both of our doorbell cameras are compatible with the Cove app and provide 2-way communication with your front door, HD resolution, and night vision. But our cameras have some important differences: Kami Doorbell Camera: The Kami Doorbell Camera is a bulkier, heavier camera than the SkyBell camera. The weight is primarily due to the battery pack that powers the camera. The battery pack can power the camera on its own or connect to the doorbell wiring to maintain a constant charge. If you decide to recharge the battery, please note that it will need to be charged at least once a month. The upside of the rechargeable battery is that your home does not need to have a doorbell currently to install this camera. It can be mounted anywhere. Unfortunately, the Kami camera is not compatible with digital doorbell chimes. SkyBell Doorbell Camera: The SkyBell Doorbell Camera is a slimmer doorbell camera than the Kami camera. It does not require a battery to operate, but it must be wired directly into your current doorbell wiring. This camera is compatible with digital doorbell chimes, but it requires an adapter, which can be purchased separately through your customer portal. In terms of features, the SkyBell camera offers a slightly wider field of view and an option for color night vision which is not provided by the Kami camera.',
  // },
];

const additionalFAQ = [
  {
    name: 'Self-Installed Security',
    questions: [
      {
        question:
          'What is the difference between self-installed and traditional home security?',
        answer: {
          col1: `Self-installed home security is different from traditional home security in two key ways. Firstly, self-installed home security does not require contracts. Most traditional security companies require contracts of up to 5 years. Secondly, self-installed security is designed so that you can set it up yourself, without any fancy tools or technicians.`,
          col2: ``,
        },
      },
      {
        question: 'What equipment does Cove offer?',
        answer: {
          col1: `Cove offers a variety of professional equipment, including a touchscreen panel with 2-way communication, indoor and outdoor cameras, anti-burglary sensors, environmental sensors, medical alerts, and key remotes.`,
          col2: ``,
        },
      },
      {
        question: 'How many sensors should I order?',
        answer: {
          col1: `The number of sensors you’ll need for your home will depend on various factors, including the size of your home, the number of doors and windows in your home, and whether or not you have pets. We recommend purchasing enough door and window sensors to cover all of your doors and ground floor windows. You’ll also want enough motion detectors to cover your halls and living spaces. One motion detector is usually enough for a smaller home. Keep in mind that our motion detectors have a 90-degree viewing angle and a range of 45 feet. You’ll also want at least one Smoke detector for your home if you do not have one already.`,
          col2: ``,
        },
      },
      {
        question: 'Do I need indoor any outdoor Security Cameras?',
        answer: {
          col1: `You’ll make the final decision, but indoor and outdoor security cameras can be helpful in a variety of situations. Cove’s indoor camera is useful if you have children and pets, so you can keep an eye on them no matter where you go. However, the outdoor camera is going to be more useful for keeping track of intruders and visitors on the outside of your home.`,
          col2: ``,
        },
      },
      {
        question: 'How do I install Cove’s security system?',
        answer: {
          col1: `To install your system, just plug in your panel and follow the instructions on the screen. The setup wizard will walk you through exactly how to name and place each of your sensors around your home. Each device comes with an adhesive strip on the back to make placing the sensors even easier. The average Cove customer sets up their security system in 27 minutes. However, it may take slightly more or less time, depending on the size of your system. If you are having trouble setting up your system, our member support team is always happy to help.`,
          col2: ``,
        },
      },
      {
        question: 'Where should I install the Touchscreen Panel?',
        answer: {
          col1: `You should install the Touchscreen Panel in a central location, close to the door you use most often. The panel creates a signal that monitors a set range of space in your home. Placing it in a central location allows us to ensure that your home is optimally covered. Sensors that are too far from the panel can lose signal, and any loss of supervision can result in a loss of security.

Placing the panel closer to the door you use regularly will make it much easier to disarm/arm every time you need to.`,
          col2: ``,
        },
      },
    ],
  },
  {
    name: 'Monitoring',
    questions: [
      {
        question: `What are Cove's monitoring plans?`,
        answer: {
          col1: `Cove offers two monitoring plans. Both plans are professionally monitored, not self-monitored. We recognize that the best protection for your home will come from a professionally monitored system. The systems we offer are shown below.

The Cove Basic plan is {monitoring-price-bm-pn}/month and includes the following elements:
24/7 Live Alarm Monitoring
Environmental Monitoring
TripleTouch Communications
Cove InstaText
Cove LiveAssist
Smash and Grab Protection
100% Cellular Connection
Hourly Automated System Checks
24 Hour Battery Backup
One Year Equipment Warranty


The Cove Plus plan is {monitoring-price-vm-pn}/month and includes all of the features of the Basic plan, plus:
Lifetime Equipment Warranty
Smartphone Control
Alexa and Google Home Voice Control
$5/Month Equipment Reward`,
          col2: ``,
        },
      },
      {
        question: 'What is the average response time for the security alarm?',
        answer: {
          col1: `In an emergency, Cove can provide faster response times by sending crucial information about your location, medical history, and type of emergency directly to dispatchers, shaving an estimated 3-4 minutes off the average emergency response time of 10 minutes.`,
          col2: ``,
        },
      },
      {
        question: 'What happens when my alarm goes off?',
        answer: {
          col1: `When an alarm is triggered, we’ll use InstaText to send you a text message to confirm the alarm. If it’s a false alarm, you can just reply “Cancel.” If you need help, respond, “Send help,” and we’ll send the authorities. We’ll also reach out to you via LiveAssist, the 2-way communication feature on your Touchscreen Panel. If we cannot reach you via these two methods, we’ll give you a phone call. If we don’t receive a response, we’ll dispatch the authorities.`,
          col2: ``,
        },
      },
      {
        question: 'What is RapidSOS?',
        answer: {
          col1: `RapidSOS is an automated system that connects Cove to thousands of dispatch centers. This system relays crucial information about your location, medical history, and type of emergency directly to dispatchers, so you don’t have to explain everything over the phone. Providing this information digitally saves 3-4 minutes of dispatch time.`,
          col2: ``,
        },
      },
      {
        question: 'Do I have to sign a long-term contract?',
        answer: {
          col1: `No. Cove will never ask you to sign a long-term contract. You can cancel at any time.`,
          col2: ``,
        },
      },
    ],
  },
  {
    name: 'Cove Basics',
    questions: [
      {
        question: 'How does the 60-day money-back guarantee work?',
        answer: {
          col1: `We think that you’ll love Cove, but we also understand that you need to find a security system that fits your needs. So, we offer 60 days of risk-free protection with Cove. You’ll still pay for your equipment upfront, but if you decide you don’t love your Cove system, you can call our service center and notify them that you would like to return your system and cancel your monitoring service. You will then ship the equipment back to us, and we will issue a refund. For more information, please reference our Refund Policy.`,
          col2: ``,
        },
      },
      {
        question:
          'Is Cove compatible with Alexa, Google Assistant, and other digital assistants?',
        answer: {
          col1: `Cove security equipment is now compatible with Alexa and Google Assistant with the Cove Plus plan. These features are integrated within the Cove Security mobile app, which gives you the option to link your Google Assistant or Alexa device. Once you have linked the device to the app, you can start using your voice commands.`,
          col2: ``,
        },
      },
      {
        question: 'Is Cove’s system wire-free?',
        answer: {
          col1: `Most of Cove’s equipment is wireless. All of the sensors and the outdoor camera run on battery power. However, the Touchscreen Panel and Indoor Camera both plug into an outlet. All sensors use a 4G cellular connection to communicate with the monitoring center; however, indoor and outdoor cameras require a WiFi connection. The sensors are also designed to stick and go, although you may choose to screw the larger sensors in place if you desire.`,
          col2: ``,
        },
      },
      {
        question: 'Does Cove offer discounts?',
        answer: {
          col1: `At Cove, we want to thank our military, school teachers, and first responders for their service and hard work. We do offer a special discount to these groups. For $150, we provide up to $475 worth of equipment, six months of professional monitoring, and 60 days risk-free.`,
          col2: ``,
        },
      },
      {
        question: 'What is the Cove referral program?',
        answer: {
          col1: `We love it when our members believe in Cove enough to share it with their family, friends, or neighbors. That’s why every time you refer a friend to us, we will give your referral $25 to use towards free equipment, and you’ll get a free month of monitoring service. The free month will show up as a credit on your Cove account.`,
          col2: ``,
        },
      },
    ],
  },
];

export { defaultFAQ, additionalFAQ };
